// extracted by mini-css-extract-plugin
module.exports = {"FourDotsContainer":"FourDots_FourDotsContainer__2F7hq"};